// List of query string params to be persisted across navigation
export default [
  'locations',
  'days',
  'from',
  'until'
];
